import {Component, OnInit} from '@angular/core';
import {MenuManagementService} from "../services/menu-management.service";
import {ModalConfirmationService} from "../../services/modal-confirmation.service";
import {GritUserRoleGroup, GritUserService, MailingList} from "../../services/grit/grit.user.service";
import {TabsService} from "../../services/tabsService";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {ReadMeComponent} from "../../popup/read-me/read-me.component";
import {from,Observable, shareReplay} from "rxjs";
import {EndpointsService} from "../../services/endpoints.service";
import {HttpClient} from "@angular/common/http";
import {ErrorLog} from "../../models/errorLog";
import {ErrorLogsDisplayComponent} from "../../popup/error-logs-display/error-logs-display.component";
import {ModalControlService} from "../../services/modal-control.service";
import {ImpactCalculationComponent} from "../../popup/grit/impact-calculation/impact-calculation.component";
import {SubscriptionListComponent} from "../../popup/grit/subscription-list/subscription-list.component";
import {MailingListComponent} from "../../popup/grit/mailing-list/mailing-list.component";
import { SelfTrainingToolService } from 'src/app/services/self-training-tool.service';
import {environment} from "../../../environments/environment";
import { UtilsService } from 'src/app/services/utils.service';
import { MenuComponent } from '../menu.component';
import { KeycloakService } from 'src/app/services/keycloak.service';
import { UserProfileComponent } from 'src/app/popup/user-profile/user-profile.component';
import { UserSpaceComponent } from 'src/app/popup/configurations/user-space/user-space.component';
import { UserSupportTicketComponent } from 'src/app/popup/user-support-ticket/user-support-ticket.component';




@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  standalone: false
})
export class UserMenuComponent implements OnInit {
  public isAdmin$: Observable<boolean>;
  readonly preReleaseToolEnabled = environment.enablePreReleaseTools;


  constructor(protected  menuService: MenuManagementService,
              protected confirmationModal: ModalConfirmationService,
              protected gritUserService: GritUserService,
              protected tabsService: TabsService,
              private endpointService : EndpointsService,
              private http: HttpClient,
              private modalService : BsModalService,
              private messageModalService : ModalControlService,
              private selfTrainingToolService: SelfTrainingToolService,
              public readonly utilsService: UtilsService,
              private keycloakService: KeycloakService,
              private popupService: BsModalService


  ) {
  }

  ngOnInit(): void {
      // Resolve once and memoize admin status for template use
      this.isAdmin$ = from(this.utilsService.userIsAdmin()).pipe(shareReplay(1));

  }

  openSubscriptionList(){
    const bsModalRef : BsModalRef = this.modalService.show(SubscriptionListComponent);
  }

  openMailingList(){
    const bsModalRef : BsModalRef = this.modalService.show(MailingListComponent);
  }

  confirmLogout(){
    this.confirmationModal.showMesssageConfirmationModal("Logout", "Are you sure you want to log out?", "Yes", "No", () => {
    environment.useB2cAuthentication ? this.menuService.logout()
      : environment.useKeycloakAuthentication ? this.keycloakService.logout(false) : MenuComponent.oldLogout();
  });
  }

  downloadPDF() : Observable<Blob>{
    const url = this.endpointService.apiUrlConfiguration + "/usermanual";

    return this.http.get<Blob>(url, {
      headers : this.endpointService.httpOptions.headers,
      responseType: 'blob' as 'json'
    })
  }

  async openGRITXwiki() {
    const loginInfo: string[] = await this.selfTrainingToolService.getLoginInfo();
    window.open(loginInfo[0], '_blank');
  }



  clickDownloadpdf() : any{
    this.downloadPDF().subscribe(res => {
      let file = res;
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
    });
  }

  openReadMeModal(){
    const bsRef:BsModalRef = this.modalService.show(ReadMeComponent);
    bsRef.content.title = "Read Me";
  }

  openAboutGritModal(){
    const bsRef:BsModalRef = this.modalService.show(ReadMeComponent);
    bsRef.content.title = "About Grit";
  }

  openSelfTrainingToolModal(){
    this.tabsService.openNewToolsTab(TabsService.SELF_TRAINING_TOOL);
  }

  openErrorLogs(){
    this.getAllErrorLogsRequest().subscribe({
      next: (errorLogs: ErrorLog[]) => {
        if (errorLogs && errorLogs.length == 0){
          this.messageModalService.showMesssageModal("Error Logs", "Currently, there are no Error Logs.");
          return;
        }
        const errorLogsByCalcType: Map<String, ErrorLog[]> = new Map();
        for (const errorLog of errorLogs){
          if (!errorLogsByCalcType.has(errorLog.calcType)){
            errorLogsByCalcType.set(errorLog.calcType, []);
          }
          errorLogsByCalcType.get(errorLog.calcType).push(errorLog);
        }
        const bsRef:BsModalRef = this.modalService.show(ErrorLogsDisplayComponent, {
          backdrop: 'static' // Prevent closing on backdrop click
        });
        bsRef.content.errorLogsByCalcType = errorLogsByCalcType;
      },
      error: error => {
        this.messageModalService.showMesssageModal("Error", "There was an error fetching Error Logs.");
      }
    })
  }

  getAllErrorLogsRequest(){
    return this.http.get<ErrorLog[]>(this.endpointService.getAllErrorLogs, this.endpointService.httpOptions);
  }

  protected logout(){
    document.cookie = "AuthToken" + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //location.reload();
    window.location.href = '/login.html';
  };

  protected readonly TabsService = TabsService;
  protected readonly GritUserRoleGroup = GritUserRoleGroup;


  openUserProfile() {
      const bsModalRef: BsModalRef = this.popupService.show(UserProfileComponent);
    }

  openUserSpace(isAdminView: boolean = false){
        const bsModalRef: BsModalRef = this.popupService.show(UserSpaceComponent, {
          initialState: { isAdminView }
        });
  }

  openUserSpaceUser() {
        this.openUserSpace(false);
  }

  openNewTicket(){
    if (!this.preReleaseToolEnabled) {
      return;
    }
    this.modalService.show(UserSupportTicketComponent, {
      backdrop: 'static'
    });
  }

  openMyTickets(): void {
    if (!this.preReleaseToolEnabled) {
      return;
    }
    this.messageModalService.openSupportTickets();

  }

  async openGRITXwikiFAQ() {

    window.open(environment.faq_url, '_blank');
  }


}
